import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ 
  selectedCount, 
  onBulkAssign, 
  onBulkRemove, 
  onClearSelection,
  loading 
}) => {
  const [bulkSector, setBulkSector] = useState('');
  const [showBulkAssign, setShowBulkAssign] = useState(false);

  const sectors = [
    { value: 'registration', label: 'Registration & Reception' },
    { value: 'kitchen', label: 'Kitchen & Food Service' },
    { value: 'security', label: 'Security & Crowd Management' },
    { value: 'medical', label: 'Medical & First Aid' },
    { value: 'transport', label: 'Transport & Logistics' },
    { value: 'decoration', label: 'Decoration & Stage Setup' },
    { value: 'audio', label: 'Audio & Technical Support' },
    { value: 'cleaning', label: 'Cleaning & Maintenance' }
  ];

  const handleBulkAssign = () => {
    if (bulkSector) {
      onBulkAssign(bulkSector);
      setBulkSector('');
      setShowBulkAssign(false);
    }
  };

  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
            <Icon name="CheckSquare" size={16} className="text-primary" />
          </div>
          <div>
            <h3 className="font-heading font-medium text-primary">
              {selectedCount} member{selectedCount !== 1 ? 's' : ''} selected
            </h3>
            <p className="text-sm text-primary/70">
              Choose an action to apply to selected members
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center space-y-2 sm:space-y-0 sm:space-x-3">
          {/* Bulk Assignment */}
          {showBulkAssign ? (
            <div className="flex items-center space-x-2">
              <Select
                placeholder="Select sector..."
                options={sectors}
                value={bulkSector}
                onChange={setBulkSector}
                className="w-48"
              />
              
              <Button
                variant="default"
                size="sm"
                onClick={handleBulkAssign}
                disabled={!bulkSector || loading}
                iconName="UserCheck"
                iconPosition="left"
              >
                Assign
              </Button>
              
              <Button
                variant="ghost"
                size="sm"
                onClick={() => {
                  setShowBulkAssign(false);
                  setBulkSector('');
                }}
                disabled={loading}
              >
                <Icon name="X" size={16} />
              </Button>
            </div>
          ) : (
            <Button
              variant="default"
              size="sm"
              onClick={() => setShowBulkAssign(true)}
              disabled={loading}
              iconName="UserPlus"
              iconPosition="left"
            >
              Bulk Assign
            </Button>
          )}

          <Button
            variant="destructive"
            size="sm"
            onClick={onBulkRemove}
            disabled={loading}
            iconName="Trash2"
            iconPosition="left"
          >
            Remove Selected
          </Button>

          <Button
            variant="outline"
            size="sm"
            onClick={onClearSelection}
            disabled={loading}
            iconName="X"
            iconPosition="left"
          >
            Clear Selection
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;